import { SecuredWsApi } from "@/utils/http-client";

export default {
  getMerchantTerms(transactionId, consultingServiceIds = []) {
    // Check if consultingServiceIds param is an array. If yes, form the data object accordingly.
    let consultingIdsQueryData = "?";
    if (Array.isArray(consultingServiceIds) && consultingServiceIds.length > 0) {
      consultingServiceIds.forEach((item) => {
        consultingIdsQueryData = consultingIdsQueryData + "consultingServiceIds=" + item.Id + "&";
      });
    }

    // Remove the last '&' from the formatted query param string
    consultingIdsQueryData = consultingIdsQueryData.slice(0, -1);

    return SecuredWsApi.get("/api/paymentflow/v1/merchant/terms-and-conditions" + consultingIdsQueryData, {
      transactionId,
    });
  },
};
